
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../redux/reducer";
import useClasses from "../../common/UseClasses";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";

const useStyles = () => ({
  container: {
    height: 440,
  },
});

type PropsFromRedux = ConnectedProps<typeof connector>;
type VVTableProps = PropsFromRedux & {
  tableData: any;
};
const CommonTable: React.FC<VVTableProps> = ({ tableData, ...rest }) => {
  const classes: any = useClasses(useStyles);
  // console.log(tableData)

  return (
    <TableContainer
      component={Paper}
      // className={classes.container}
      sx={{
        borderWidth: 1,
        borderColor: "lightgray",
        borderStyle: "solid",
        height:440
      }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow key={"table-header"}>
            {tableData?.tableHeader.map((headerData: any, i: number) => (
              <TableCell
                key={i}
                align={"center"}
                sx={{
                  fontSize: 12,
                  color: "black",
                  fontWeight: 700,
                }}
              >
                {headerData.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData?.tableRow?.map((row: any, i: number) => {
            return (
              <TableRow hover key={i}>
                {Object.values(row).map((value: any, index: number) => {
                  return (
                    <TableCell
                      key={index}
                      align={"center"}
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {row["change"] &&
                      row["change"] === value &&
                      !isNaN(value) ? (
                        <span
                          className="icon"
                          style={{ color: value >= 0 ? "green" : "red" }}
                        >
                          {value >= 0 ? <ArrowDropUp /> : <ArrowDropDown />}

                          {Math.abs(value).toFixed(2)}
                        </span>
                      ) : (
                        value
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
const mapState = (state: RootState) => ({});

const mapDispatch = {};

const connector = connect(mapState, {});
export default connector(CommonTable);
